export const accountTypes = ["INDIVIDUAL", "JOINT", "TRUST"];
export const accountTypesV2 = [
    "INDIVIDUAL",
    "JOINT",
    "TRUST",
    "IRA",
    "ROTH_IRA",
    "SIMPLE_IRA",
    "BENEFICIARY_ROTH_IRA",
];
//# sourceMappingURL=Types.js.map